import styled from 'styled-components';
import { YabbleLogo } from 'components/YabbleLogo/YabbleLogo';

export const LayoutDashboardLeftMenuLogoStyle = {
  YabbleLogo: styled(YabbleLogo)`
    height: 24px;
    width: 77px;
  `,
};
